module.exports = __webpack_public_path__ + "img/prizeOne.ef0015bb.png";